import React, { useState, useEffect } from "react";
import DebounceFilter from "../../components/filter/DebounceFilter";
import CustomerWithDevicesList from "../../components/devices/CustomerWithDevicesList";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { setSelectedSystems } from "../../ducks/customersDuck";
import { Box, Checkbox, Stack, Typography, useTheme } from "@mui/material";
import { useMsal } from "Auth/msal-context";
import { useCustomersList } from '../../hooks/useCloudSelectors';

const CustomerListContainer = ({ selectedSystems, selectedSensorSite, sensorManagementView }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = useTheme();
  const { isAdmin } = useMsal();

  const customers = useCustomersList();

  const sensorCustomers = customers.filter((customer) =>
    customer.devices.some((device) => device.solutionType === "lora")
  );


  const [filterValue, setFilterValue] = useState("");

  const [filteredCustomers, setFilteredCustomers] = useState(sensorManagementView ? sensorCustomers : customers);

  useEffect(() => {
    if (filterValue === "") {
      setFilteredCustomers(sensorManagementView ? sensorCustomers : customers);
    } else {
      // Filter customers based on the filterValue
      const lowerFilterValue = filterValue.toLowerCase();
      setFilteredCustomers(
        sensorManagementView
          ? sensorCustomers.filter(
            (customer) =>
              customer.customerName.toLowerCase().includes(lowerFilterValue) ||
              customer?.devices?.some((device) => device.deviceName.toLowerCase().includes(lowerFilterValue))
          )
          : customers.filter(
            (customer) =>
              customer.customerName.toLowerCase().includes(lowerFilterValue) ||
              customer?.devices?.some((device) => device.deviceName.toLowerCase().includes(lowerFilterValue))
          )
      );
    }
  }, [filterValue, customers]);


  const [showIds, setShowIds] = useState(JSON.parse(localStorage.getItem("showIds")) || false);
  const toggleShowIds = (e) => {
    e.stopPropagation();
    setShowIds(!showIds);
    localStorage.setItem("showIds", JSON.stringify(!showIds));
  };

  const handleDebounceFilter = (e) => {
    const filter = e.target.value.toLowerCase() || "";
    setFilterValue(filter);
  };

  useEffect(() => {
    if (location.pathname !== "map" && customers.length > 0) {
      const storageDevices = localStorage.getItem("selectedSystems");
      if (storageDevices) {
        dispatch(
          setSelectedSystems({
            devices: JSON.parse(storageDevices),
            path: "devices",
          })
        );
      }
    }
  }, [customers]);

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", flexDirection: "row", backgroundColor: theme.palette.background.paper }}>
        <Box sx={{ flexGrow: 1 }}>
          <DebounceFilter handleDebounceFilter={handleDebounceFilter} />
        </Box>
        {isAdmin && (
          <Stack direction="column" alignItems="center" sx={{ margin: "0px 4px" }}>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
              IDs
            </Typography>
            <Checkbox checked={showIds} onChange={(e) => toggleShowIds(e)} />
          </Stack>
        )}
      </Box>
      <CustomerWithDevicesList
        showIds={showIds}
        customers={filteredCustomers}
        selectedSystems={selectedSensorSite ? [selectedSensorSite] : selectedSystems} // NOTE! selectedSensorSite needs to be an array for CustomerWithDevicesList
        sensorManagementView={sensorManagementView}
      />
    </>
  );
};

export default CustomerListContainer;
